export const getApiUrl = () => {
  const isLocal = window.location.host.indexOf('localhost') !== -1
  return isLocal
    ? 'http://localhost:8003/it-api'
    : 'https://intranet.magno-it.nl/it-api'
}

const config = {
  baseUrl: getApiUrl(),
}

export const getSessionId = (): string => {
  const magnoToken = localStorage.getItem('MagnoToken')
  return magnoToken || ''
}

export const authedGet = async (path: string) => {
  const result = await fetch(`${config.baseUrl}/${path}`, {
    method: 'GET',
    headers: {
      'X-authenticated': getSessionId(),
    },
  })
  return result
}

const authedMutate = async (method: string, path: string, body: any) => {
  const result = await fetch(`${config.baseUrl}/${path}`, {
    method,
    headers: {
      'X-authenticated': getSessionId(),
      'content-type': 'application/json',
    },
    body: body,
  })
  return result
}

export const authedPost = async (path: string, body: any) => {
  return await authedMutate('POST', path, body)
}

export const authedPut = async (path: string, body: any) => {
  return await authedMutate('PUT', path, body)
}

export const authedDelete = async (path: string, body?: any) => {
  return await authedMutate('DELETE', path, body)
}
